import React, { useState } from 'react';
import './Mywork.css';
import { mywork_data } from '../../assets/mywork_data';

const Mywork = () => {
  const [showAll, setShowAll] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const visibleData = showAll ? mywork_data : mywork_data.slice(0, 4);

  const handleShowMore = () => {
    setShowAll(!showAll);
  };

  const handleOpenPopup = (project) => {
    setSelectedProject(project);
  };

  const handleClosePopup = () => {
    setSelectedProject(null);
  };

  return (
    <div id='work' className="mywork">
      <div className="mywork-title">
        <h1>My Latest Work</h1>
      </div>

      <div className="mywork-container">
        {visibleData.map((work, index) => (
          <div key={index} className="project-card">
            <img src={work.w_img} alt={work.w_name} />
            <div className="overlay">

            <button className="details-btn" onClick={() => handleOpenPopup(work)}>
              Project Details
            </button>
            </div>
          </div>
        ))}
      </div>

      {mywork_data.length > 4 && (
        <div className="mywork-showmore" onClick={handleShowMore}>
          {showAll ? "Show Less" : "Show More"}
        </div>
      )}

      {selectedProject && (
        <div className="popup-overlay" onClick={handleClosePopup}>
          <div className="popup-content" onClick={e => e.stopPropagation()}>
            <h2>Progect Name: {selectedProject.w_name}</h2>
            <p>Description: {selectedProject.description}</p>
            <h4>Technologies Used:</h4>
            <ul>
              {selectedProject.technologies.map((tech, i) => <li key={i}>{tech}</li>)}
            </ul>
            <button onClick={handleClosePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Mywork;
